import { LoaderCircle } from "lucide-react";
import type { ButtonHTMLAttributes } from "react";

type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  busy?: boolean;
};

export function Button({ variant = "primary", busy = false, className, children, disabled, ...props }: ButtonProps) {
  return (
    <button
      className={["ui-button", `ui-button--${variant}`, className].filter(Boolean).join(" ")}
      disabled={disabled || busy}
      aria-busy={busy || undefined}
      {...props}
    >
      {busy ? <LoaderCircle className="ui-button__spinner" aria-hidden="true" size={16} /> : null}
      <span className="ui-button__content">{children}</span>
    </button>
  );
}

export function IconButton({ className, children, ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button className={["ui-icon-button", className].filter(Boolean).join(" ")} {...props}>{children}</button>;
}
